<template>
  <div id="app">
    <div class="m-cover"></div>
    <div class="m-viewport">
        <schedules class="body-item" :mpl_list="mpl_list" :week_list="week_list" :active="data_load.indexOf(0) > -1?true:false"/>
        <media class="body-item" :active="data_load.indexOf(1) > -1?true:false"/>
        <view-video class="body-item" :active="data_load.indexOf(2) > -1?true:false"/>
        <score class="body-item" :mpl_list="mpl_list" :week_list="week_list" :active="data_load.indexOf(3) > -1?true:false"/>
        <gamedata class="body-item" :mpl_list="mpl_list" :mpl_list_hero="mpl_list" :active="data_load.indexOf(4) > -1?true:false"/>
        <team class="body-item" :active="data_load.indexOf(5) > -1?true:false"/>
        <anchor class="body-item" :active="data_load.indexOf(6) > -1?true:false"/>
        <corp class="body-item" :active="data_load.indexOf(7) > -1?true:false"/>
    </div>
    <div class="u-nav" :class="{'fixed' : headerFixed}">
        <div class="wrapper">
            <div class="nav-item nav-trriger u-btn" :class="{'act' : active==0}" @click="scrollTo(0)">近期赛程</div>
            <div class="nav-item nav-trriger u-btn" :class="{'act' : active==1}" @click="scrollTo(1)">直播资讯</div>
            <div class="nav-item nav-trriger u-btn" :class="{'act' : active==2}" @click="scrollTo(2)">视频中心</div>
            <div class="nav-item nav-trriger u-btn" :class="{'act' : active==3}" @click="scrollTo(3)">赛程积分</div>
            <div class="nav-item nav-trriger u-btn" :class="{'act' : active==4}" @click="scrollTo(4)">数据排行</div>
            <div class="nav-item nav-trriger u-btn" :class="{'act' : active==5}" @click="scrollTo(5)">参赛战队</div>
            <div class="nav-item nav-trriger u-btn" :class="{'act' : active==6}" @click="scrollTo(6)">赛事解说</div>
            <div class="nav-item nav-trriger u-btn" :class="{'act' : active==7}" @click="scrollTo(7)">合作伙伴</div>

            <div class="u-btn btn-top" @click="scrollTo(-1)"></div>
        </div>
    </div>
    <!-- <div class="sample"></div>     -->
  </div>
</template>

<script>
import schedules from '@/components/page/schedules'
import media from '@/components/page/media'
import view_video from '@/components/page/video'
import score from '@/components/page/score'
//TODO
import gamedata from '@/components/page/gameData'
import team from '@/components/page/team'
import anchor from '@/components/page/anchor'
import corp from '@/components/page/corp'

export default {
  name: 'App',
  components: {
    schedules,
    media,
    'view-video' : view_video,
    score,
    gamedata,
    team,
    anchor,
    corp,
  },
  data (){
    return{
        active : 0,
        data_load : [],
        item_top_data : [],
        headerFixed : false,      
    }
  },
  props : {
    mpl_list : {
      default: () => [],
    },
    week_list : {
      default: () => [],
    },    
  },
  mounted (){
      this.collect_top_data();
      this.$nextTick(function () {
          window.addEventListener('scroll', this.handleScroll)
      })        
  },
  provide () {
      return {
          reload: this.collect_top_data,
      }
  },      
  methods : {
    handleScroll () {
        var self = this;
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop//获取滚动距离
        this.scrollTop = scrollTop//data里return了一个全局的scrollTop
        this.headerFixed = scrollTop > 1150

        var result = collectActiveNav(100);
        this.active = result[0];

        var result_data = collectActiveNav(500);
        this.data_load = result_data;        

        function collectActiveNav(delta){
            var ret = [] ;

            let body_item = document.querySelectorAll('.body-item');

            for (var i = 0; i < body_item.length; i++) {
                let ele = body_item[i];
                if (inViewport(i,delta,ele)){
                    ret.push(i);
                }                                 
            }

            return ret;
        };

        function inViewport(i, delta,ele){
            var top = self.item_top_data[i],
                scrollTop = self.scrollTop;
            
            delta = delta || 100;
            
            //return top + delta > scrollTop && top - delta < scrollTop + document.documentElement.clientHeight;
            return top - delta + ele.offsetHeight > scrollTop && top - delta < scrollTop + document.documentElement.clientHeight;
        };	         
    },
    collect_top_data (){
        let body_item = document.querySelectorAll('.body-item');

        for (var i = 0; i < body_item.length; i++) {
            this.item_top_data.push(body_item[i].offsetTop);
        }
        
    },
    scrollTo(index){
        // 定义一次跳 50 个像素，数字越大跳得越快，但是会有掉帧得感觉
        const STEP = 50
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop//获取滚动距离
        let body_item = document.querySelectorAll('.body-item');
        let top = index == -1 ? 0 : body_item[index].offsetTop;
        var targetOffsetTop = top;

        if (scrollTop < targetOffsetTop) {
            // 往下滑
            smoothDown()
        }else{
            smoothUp()
        }
        // 定义下滑函数
        function smoothDown() {
            // 如果当前 scrollTop 小于 targetOffsetTop 说明视口还没滑到指定位置
            if (scrollTop < targetOffsetTop) {
                if (targetOffsetTop - scrollTop >= STEP) {
                    scrollTop += STEP
                } else {
                    scrollTop = targetOffsetTop
                }
                document.body.scrollTop = scrollTop
                document.documentElement.scrollTop = scrollTop
                // 屏幕在绘制下一帧时会回调传给 requestAnimationFrame 的函数
                requestAnimationFrame(smoothDown)
            }
        }
        // 定义上滑函数
        function smoothUp() {
            // 如果当前 scrollTop 大于 targetOffsetTop 说明视口已经滑过指定位置需要上滑
            if (scrollTop > targetOffsetTop) {
                if (scrollTop - targetOffsetTop >= STEP) {
                    scrollTop -= STEP
                } else {
                    scrollTop = targetOffsetTop
                }
                document.body.scrollTop = scrollTop
                document.documentElement.scrollTop = scrollTop
                requestAnimationFrame(smoothUp)
            }
        }
    },      
  },
}
</script>

<style>
body{
  background-color: #333;
}

#app{
  position: relative;
  max-width: 1920px;
  height: 7500px;
  margin: 0 auto;
  background-color: #fff;
  background-image: url(~@/assets/images/body.jpg);
  background-position: top center;  
}

.sample{
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 1920px;
  height: 8600px;
  background-image: url(~@/assets/images/web.jpg);
  opacity: .6;
  z-index: 10;
}

.m-cover{
  width: 100%;
  height: 863px;
  background-image: url(~@/assets/images/cover.jpg);
  background-position: top center;
  background-repeat: no-repeat;
}

.m-viewport{
  width: 1400px;
  margin: 0 auto;
  padding-top: 118px;
}

.u-btn{
  cursor: pointer;
}

.u-loading{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}

.u-loading .gif{
  width: 48px;
  height: 48px;
  margin: 0 auto;
  background-image: url(~@/assets/images/loading.gif);
}

.u-loading p{
  font-size: 14px;
  color: #fff;
  text-align: center;
}

.u-nav {
    position: absolute;
    right: 2%;
    top: 1150px;
    width: 155px;
    height: 485px;
    padding-top: 10px;
    box-sizing: border-box;
    /* background-image: url(~@/assets/images/side-nav.png);
    background-position: top center;
    background-repeat: no-repeat; */
    background-color: #fff;
    z-index: 10;
    border: 1px solid #d7a444;
}

@media screen and (max-width: 1400px){
  .u-nav{
    display: none;
  }
}

.u-nav.fixed{
    position: fixed;
    top: 50px;
}

.nav-item {
    width: 155px;
    height: 50px;
    line-height: 50px;
    margin: 0 auto;
    font-size: 18px;
    font-weight: 700;
    color: #676767;
    text-align: center;
}

.nav-item.act{
    color: #d7a444;
    text-decoration: underline;
}

.nav-item a{
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    z-index: 5;
}

.btn-top{
    width: 155px;
    height: 64px;
    margin: 10px auto 0;
    background-image: url(~@/assets/images/top.png);
}

.btn-top:hover{
  background-image: url(~@/assets/images/top_act.png);
}

.u-btn.disabled{
    cursor: not-allowed;
    filter: url("data:image/svg+xml;utf8,#grayscale");
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
    filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);  
}
</style>



// WEBPACK FOOTER //
// src/App.vue